import React from "react";

import { useTranslation } from "react-i18next";

import { Checkbox } from "@/src/components/ui/checkbox";

import {
  SELECT_CHECKBOX_CLASS,
  SELECT_CHECKBOX_WRAPPER_CLASS,
} from "./dataTableStyles";

import type { RowData } from "@tanstack/react-table";
import type { JSX } from "react";

import type { DataTableRow } from "./dataTable.types";

interface DataTableSelectCellProps<TData extends RowData> {
  row: DataTableRow<TData>;
  rowLabel: string;
}

function DataTableSelectCell<TData extends RowData>({
  row,
  rowLabel,
}: DataTableSelectCellProps<TData>): JSX.Element {
  const { t } = useTranslation("table");

  return (
    <div className={SELECT_CHECKBOX_WRAPPER_CLASS}>
      <Checkbox
        aria-label={t("dataTable.selectRow", { row: rowLabel })}
        checked={row.getIsSelected()}
        className={SELECT_CHECKBOX_CLASS}
        onCheckedChange={(value) => row.toggleSelected(value === true)}
      />
    </div>
  );
}

export default DataTableSelectCell;
